import React from 'react';
import { I18n } from '@aws-amplify/core';
import { ColumnsType } from 'antd/es/table';
import { Table } from 'antd';

import { RISK_LEVEL_COLORS } from '@/components/views/Report/KimLhc/Report/Steps/Result/Constants';
import type { RiskLevel } from '@/types';

import { formatScore, RiskSummary } from './utils';

import * as S from './styles';

interface GenderRow {
	key: React.Key;
	score: string;
	probability: string;
	consequences: string;
	measures: string;
}

interface GenderDetailRowProps {
	label: string;
	score: number;
	risk: RiskLevel;
	summary: RiskSummary;
}

export function GenderDetailRow(props: Readonly<GenderDetailRowProps>): JSX.Element {
	const { label, score, risk, summary } = props;

	const columns: ColumnsType<GenderRow> = [
		{
			title: I18n.get(label),
			dataIndex: 'score',
			key: 'score',
			width: '25%'
		},
		{
			title: I18n.get('Probability of physical overload'),
			dataIndex: 'probability',
			key: 'probability',
			width: '25%'
		},
		{
			title: I18n.get('Possible health consequences'),
			dataIndex: 'consequences',
			key: 'consequences',
			width: '25%'
		},
		{
			title: I18n.get('Measures'),
			dataIndex: 'measures',
			key: 'measures',
			width: '25%'
		}
	];

	const dataColumn: GenderRow[] = [
		{
			key: label,
			score: formatScore(score, risk),
			probability: summary.risk_level,
			consequences: summary.health_consequences,
			measures: summary.measures
		}
	];

	return (
		<S.KimLhcGenderRowContainer $riskColor={RISK_LEVEL_COLORS[risk]}>
			<Table columns={columns} dataSource={dataColumn} pagination={false} />
		</S.KimLhcGenderRowContainer>
	);
}
